import React, { useState } from 'react';
import './Conferences.css';

const conferencesData = [
  {
    id: 1,
    title: "Localized Chemo-Antiangiogenic Therapy Using an Injectable GelMA Hydrogel for Synergistic Regression of Aggressive Solid Tumors ",
    authors: "Rajat Dadheech, Biman B. Mandal ",
    conference: "TransMatter Conference 2026",
    fullConferenceName: "International Conference on Transforming Medical science And Technology through Tissue Engineering & Regenerative medicine 2026 ",
    institution: "IIT Kharagpur, West Bengal, India ",
    date: "September 5- 6, 2026",
    year: "2026",
    presentationType: "Oral",
    award: "BEST ORAL PRESENTATION AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Bioengineered 3D in vitro aged skin model for high- throughput anti- aging therapeutic screening",
    authors: "Victoria J., Biman B. Mandal ",
    conference: "TransMatter Conference 2026",
    fullConferenceName: "International Conference on Transforming Medical science And Technology through Tissue Engineering & Regenerative medicine 2026 ",
    institution: "IIT Kharagpur, West Bengal, India ",
    date: "September 5- 6, 2026",
    year: "2026",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "Instant Protection Nano-Spary Bandage Driven Antiscar Wound Healing",
    authors: "Kodieswaran M, Biman B. Mandal ",
    conference: "TERMIS-AP 2025",
    fullConferenceName: "Termis AP Virtual Student Paper Contest - Tissue Engineering and Regenerative Medicine International Society -Asia Pacific Chapter ",
    institution: "Wenzhou, China ",
    date: "December 5- 6, 2025",
    year: "2025",
    presentationType: "Oral",
    award: "ORAL PRESENTATION SILVER AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "In vitro human biomimetic liver model",
    authors: "Souradeep Dey, Biman B. Mandal ",
    conference: "WBC 2024",
    fullConferenceName: "12th World Biomaterials Congress (WBC 2024) ",
    institution: "Daegu, Republic of Korea ",
    date: "May 26 – May 31, 2024",
    year: "2024",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "Silk based bioactive spray bandage for treatment of chronic diabetic wounds",
    authors: "Manikumar Kodieswaran, Biman B. Mandal ",
    conference: "FINS 2024",
    fullConferenceName: "Frontiers in Nano-Sciences (FINS) India ",
    institution: "Centre for Nanotechnology, IIT Guwahati, India ",
    date: "November 1- 2, 2024",
    year: "2024",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "Injectable hydrogel for osteoarthritis management",
    authors: "Chevella Maheshwari, Biman B. Mandal ",
    conference: "IJWBME 2024",
    fullConferenceName: "India-Japan Workshop on Biomolecular Electronics and Organic Nanotechnology for Environment (IJWBME) ",
    institution: "Centre for Nanotechnology, IIT Guwahati, India ",
    date: "November 19- 21, 2024",
    year: "2024",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "Dr. Himangshu Roy Memorial Young Scientist Award",
    authors: "Souradeep Dey, Biman B. Mandal ",
    conference: "",
    fullConferenceName: "Dr. Himangshu Roy Memorial Young Scientist Award 2023 ",
    institution: "The Zoological Society, Kolkata, India ",
    date: "",
    year: "2023",
    presentationType: "Oral",
    award: "AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Indian National Young Academy of Science",
    authors: "Dr. G. Janani ",
    conference: "INYAS 2023",
    fullConferenceName: "Indian National Young Academy of Science (INYAS 2023) ",
    institution: "IIT (ISM) Dhanbad, Jharkhand, India",
    date: "15–17 September 2023",
    year: "2023",
    presentationType: "Oral",
    award: "INYAS BEST THESIS AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Tissue Engineering and Regenerative Medicine International Society – Asia Pacific Chapter",
    authors: "Chitra Jaiswal, Biman B. Mandal",
    conference: "TERMIS-AP Webinar Student Presentation Contest",
    fullConferenceName: "Tissue Engineering and Regenerative Medicine International Society – Asia Pacific (TERMIS-AP) Chapter ",
    institution: "Hong Kong Science Park in Shatin, Hong Kong",
    date: "October 16–19, 2023",
    year: "2023",
    presentationType: "Oral",
    award: "ORAL PRESENTATION BRONZE AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "International Conference on Biomaterials, Regenerative Medicine and Devices",
    authors: "Chitra Jaiswal, Biman B. Mandal",
    conference: "BIOREMEDI 2022",
    fullConferenceName: "BIOREMEDI- Society for Biomaterials and Artificial Organs (India) ",
    institution: "IIT Guwahati, India",
    date: "December 14–18, 2022",
    year: "2022",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "International Conference on Biomaterials, Regenerative Medicine and Devices",
    authors: "Bibrita Bhar, Biman B. Mandal",
    conference: "BIOREMEDI 2022",
    fullConferenceName: "BIOREMEDI- Society for Biomaterials and Artificial Organs (India) ",
    institution: "IIT Guwahati, India",
    date: "December 14–18, 2022",
    year: "2022",
    presentationType: "Oral",
    award: "BEST ORAL PRESENTATION AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "International Conference on Biomaterials, Regenerative Medicine and Devices",
    authors: "Souradeep Dey, Biman B. Mandal",
    conference: "BIOREMEDI 2022",
    fullConferenceName: "BIOREMEDI- Society for Biomaterials and Artificial Organs (India) ",
    institution: "IIT Guwahati, India",
    date: "December 14–18, 2022",
    year: "2022",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "International Conference on Biomaterials, Regenerative Medicine and Devices",
    authors: "Sayanti Shome, Biman B. Mandal",
    conference: "BIOREMEDI 2022",
    fullConferenceName: "BIOREMEDI- Society for Biomaterials and Artificial Organs (India) ",
    institution: "IIT Guwahati, India",
    date: "December 14–18, 2022",
    year: "2022",
    presentationType: "Poster",
    award: "ACS POSTER AWARD",
    category: "Poster"
  },
  {
    id: 1,
    title: "International Conference on Biomaterials, Regenerative Medicine and Devices",
    authors: "Ashutosh Bandyopadhyay, Biman B. Mandal",
    conference: "BIOREMEDI 2022",
    fullConferenceName: "BIOREMEDI- Society for Biomaterials and Artificial Organs (India) ",
    institution: "IIT Guwahati, India",
    date: "December 14–18, 2022",
    year: "2022",
    presentationType: "Oral",
    award: "BAJPAI-SAHA STUDENT AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Development of a Silk-based Composite Hydrogel Functionalized with Bioactive Molecules for Potential Wound Healing Applications",
    authors: "Bibrita Bhar Biman B. Mandal",
    conference: "SPACS 2021",
    fullConferenceName: "SPACS 2021- International Symposium on Smart Polymers: Application in Current Scenario (SPACS) 2021 organized by Asian Polymer Association (APA), 2021 ",
    institution: "Amity University, Noida, Uttar Pradesh, India",
    date: "January 15–16, 2021",
    year: "2021",
    presentationType: "Oral",
    award: "BEST FLASH TALK PRESENTATION AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Indian National Young Academy of Science",
    authors: "Dr. Dimple Chouhan",
    conference: "INYAS 2021",
    fullConferenceName: "Indian National Young Academy of Science (INYAS 2021) ",
    institution: "Virtual mode",
    date: "February 18–21, 2021",
    year: "2021",
    presentationType: "Oral",
    award: "INYAS BEST THESIS AWARD",
    category: "Oral"
  },
  {
    id: 1,
    title: "Society for Interdisciplinary Research in Materials and Biology",
    authors: "Ashutosh Bandyopadhyay, Biman B. Mandal",
    conference: "Advanced Material For Better Tomorrow-2021",
    fullConferenceName: "International Conference On Advanced Material For Better Tomorrow-2021 ",
    institution: "IIT BHU, Uttar Pradesh, India",
    date: "August 11- 13, 2021",
    year: "2021",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Poster"
  },
  {
    id: 2,
    title: "International e-symposium on Smart Polymers: Application in current scenario",
    authors: "Chitra Jaiswal, Biman B. Mandal",
    conference: "SPACS-2021",
    fullConferenceName: "SPACS-2021- International e-symposium on Smart Polymers: Application in current scenario",
    institution: "Amity Institute of Applied Sciences, Amity University, Uttar Pradesh, India",
    date: "January 15–16, 2021",
    year: "2021",
    presentationType: "Poster",
    award: "BEST ORAL PRESENTATION AWARD",
    category: "Symposium"
  },
  {
    id: 1,
    title: "Nonmulberry silk fibroin based functionalized nanofibrous mats as potential wound dressing material",
    authors: "Dimple Chouhan, Bijayshree Chakraborty, Samit K. Nandi, Biman B. Mandal",
    conference: "BiTERM 2016",
    fullConferenceName: "International conference on Biomaterials, Biodiagnostics, Tissue Engineering, Drug delivery and Regenerative medicine",
    institution: "Indian Institute of Technology Delhi",
    date: "April 15-17, 2016",
    year: "2016",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Wound Care"
  },
  {
    id: 2,
    title: "Silk fibre reinforced silk scaffolds for cartilage tissue engineering",
    authors: "Yogendra P. Singh, Mimi Adhikary, Salma Jasmine, Biman B. Mandal",
    conference: "BiTERM 2016",
    fullConferenceName: "International conference on Biomaterials, Biodiagnostics, Tissue Engineering, Drug delivery and Regenerative medicine",
    institution: "Indian Institute of Technology Delhi",
    date: "April 15-17, 2016",
    year: "2016",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Tissue Engineering"
  },
  {
    id: 3,
    title: "Bioengineered silk grafts for small diameter blood vessel replacement",
    authors: "Prerak Gupta, Manishekhar Kumar, Nandana Bhardwaj, Jadi Praveen Kumar, CS Krishnamurthy, Biman B. Mandal",
    conference: "BiTERM 2016",
    fullConferenceName: "International conference on Biomaterials, Biodiagnostics, Tissue Engineering, Drug delivery and Regenerative medicine",
    institution: "Indian Institute of Technology Delhi",
    date: "April 15-17, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Cardiovascular"
  },
  {
    id: 4,
    title: "Silk-based Macro Encapsulates for Sustained Insulin Release",
    authors: "Biman B. Mandal, Manishekhar Kumar",
    conference: "4th TERMIS World Congress",
    fullConferenceName: "4th TERMIS World Congress",
    location: "Boston, USA",
    date: "September 10, 2015",
    year: "2015",
    presentationType: "Oral",
    category: "Drug Delivery"
  },
  {
    id: 5,
    title: "Bioengineered silk vascular grafts for bypass surgery",
    authors: "Prerak Gupta, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Cardiovascular"
  },
  {
    id: 6,
    title: "Exploring silk fibroin based nanofibrous matrix as skin substitute material",
    authors: "Dimple Chouhan, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Wound Care"
  },
  {
    id: 7,
    title: "Bioengineered silk construct: A prospective solution to intervertebral disc degeneration",
    authors: "Bibhas K. Bhunia, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Orthopedic Devices"
  },
  {
    id: 8,
    title: "Silk based Biomimetic approach for cardiac tissue engineering",
    authors: "Shreya Mehrotra, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 9,
    title: "Silk/agarose hydrogel for cartilage tissue engineering",
    authors: "Yogendra P. Singh, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 10,
    title: "Exploring silk fibroin scaffolds in liver tissue engineering",
    authors: "M Janani G, Biman B. Mandal",
    conference: "Research Conclave 2016",
    fullConferenceName: "Research Conclave 2016",
    institution: "Indian Institute of Technology Guwahati",
    date: "March 17-20, 2016",
    year: "2016",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 11,
    title: "Antioxidant Potency of North-East Indian Silkworm Cocoon Based Sericin",
    authors: "Jadi Praveen Kumar, Biman B. Mandal",
    conference: "APST-2015",
    fullConferenceName: "Advances in Polymer Science & Technology National conference",
    institution: "IASST, Guwahati, India",
    date: "March 13, 2015",
    year: "2015",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Biomaterial Processing"
  },
  {
    id: 12,
    title: "Novel silk macro-encapsulates for prolonged islet viability and sustained insulin release",
    authors: "Manishekhar Kumar, Biman B. Mandal",
    conference: "APST-2015",
    fullConferenceName: "Advances in Polymer Science & Technology National conference",
    institution: "IASST, Guwahati, India",
    date: "March 13, 2015",
    year: "2015",
    presentationType: "Poster",
    award: "BEST POSTER AWARD",
    category: "Drug Delivery"
  },
  {
    id: 13,
    title: "Small diameter tissue engineered blood vessel",
    authors: "Prerak Gupta, Manishekhar Kumar, Jadi Praveen Kumar, Biman B. Mandal",
    conference: "APST-2015",
    fullConferenceName: "Advances in Polymer Science & Technology National conference",
    institution: "IASST, Guwahati, India",
    date: "March 13, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Cardiovascular"
  },
  {
    id: 14,
    title: "Mulberry and non-mulberry silk fibroin based electrospun mats as skin-substitute materials",
    authors: "Dimpal Chouhan, Biman B. Mandal",
    conference: "APST-2015",
    fullConferenceName: "Advances in Polymer Science & Technology National conference",
    institution: "IASST, Guwahati, India",
    date: "March 13, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Wound Care"
  },
  {
    id: 15,
    title: "Silk Based Bio-Artificial Pancreas",
    authors: "Manishekhar Kumar, Biman B. Mandal",
    conference: "ICPB 2014",
    fullConferenceName: "International Conference on Polymeric Biomaterials, Bioengineering & Biodiagnostics",
    location: "Rome, Italy",
    date: "October 27-30, 2014",
    year: "2014",
    presentationType: "Poster",
    category: "Drug Delivery"
  },
  {
    id: 16,
    title: "Silk based injectable hydrogel as potential cell delivery matrix",
    authors: "Garima Singh, Manishekhar Kumar, Biman B. Mandal",
    conference: "APST-2015",
    fullConferenceName: "Advances in Polymer Science & Technology National conference",
    institution: "IASST, Guwahati, India",
    date: "March 13, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Drug Delivery"
  },
  {
    id: 17,
    title: "Silk based biomaterials for cardiac tissue engineering",
    authors: "Shreya Mehrotra, Biman B. Mandal",
    conference: "ASP-15",
    fullConferenceName: "Advances in sustainable polymer symposium",
    institution: "IIT Guwahati, India",
    date: "January 21-22, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 18,
    title: "Silk Based Pancreatic Tissue Engineering",
    authors: "Manishekhar Kumar, Biman B. Mandal",
    conference: "ASP-15",
    fullConferenceName: "Advances in sustainable polymer symposium",
    institution: "IIT Guwahati, India",
    date: "January 21-22, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 19,
    title: "Magnetic-field Responsive Electrospun Silk Fibroin Mats",
    authors: "Rocktotpal Konwarh, Biman B. Mandal",
    conference: "ASP-15",
    fullConferenceName: "Advances in sustainable polymer symposium",
    institution: "IIT Guwahati, India",
    date: "January 21-22, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Biomaterial Processing"
  },
  {
    id: 20,
    title: "A novel approach to fabricate silk-based small diameter vascular grafts",
    authors: "Prerak Gupta, Manishekhar Kumar, Jadi Praveen Kumar, Salma Jasmine, Biman B. Mandal",
    conference: "ASP-15",
    fullConferenceName: "Advances in sustainable polymer symposium",
    institution: "IIT Guwahati, India",
    date: "January 21-22, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Cardiovascular"
  },
  {
    id: 21,
    title: "Mulberry and Non-Mulberry Silk Sericin Blended Polymer Matrices",
    authors: "Jadi Praveen Kumar, Biman B. Mandal",
    conference: "ASP-15",
    fullConferenceName: "Advances in sustainable polymer symposium",
    institution: "IIT Guwahati, India",
    date: "January 21-22, 2015",
    year: "2015",
    presentationType: "Poster",
    category: "Biomaterial Processing"
  },
  {
    id: 22,
    title: "Indian Silk: From Textiles to Tissue Engineering",
    authors: "Biman B. Mandal",
    conference: "International Silk Conference",
    fullConferenceName: "International Silk Conference",
    institution: "Fudan and Soochow University",
    location: "Shanghai, China",
    date: "October 8-12, 2014",
    year: "2014",
    presentationType: "Oral",
    category: "Biomaterial Processing"
  },
  {
    id: 23,
    title: "Silk Matrix Based Tissue Engineering",
    authors: "Biman B. Mandal",
    conference: "Healthcare India",
    fullConferenceName: "Healthcare India Conference",
    location: "New Delhi",
    date: "February 20-23, 2012",
    year: "2012",
    presentationType: "Oral",
    category: "Tissue Engineering"
  },
  {
    id: 24,
    title: "Silk: A promising Biomaterial for Tissue Engineering",
    authors: "Biman B. Mandal",
    conference: "MIBISEM-2013",
    fullConferenceName: "MIBISEM Conference",
    institution: "North Bengal University",
    location: "Siliguri, India",
    date: "February 25-26, 2013",
    year: "2013",
    presentationType: "Oral",
    category: "Biomaterial Processing"
  },
  {
    id: 25,
    title: "Role of tissue architecture towards functionality: A silk study",
    authors: "Biman B. Mandal",
    conference: "MMDRM-2014",
    fullConferenceName: "International conference on Medical materials, devices and regenerative medicine",
    location: "Kathmandu, Nepal",
    date: "January 11-13, 2014",
    year: "2014",
    presentationType: "Oral",
    category: "Tissue Engineering"
  },
  {
    id: 26,
    title: "Hydrogel infused 3D silk scaffolds for controlled drug release",
    authors: "Saket K. Singh, Biman B. Mandal",
    conference: "TERMIS AP 2013",
    fullConferenceName: "TERMIS AP International conference",
    location: "Shanghai-Wuzhen, China",
    date: "October 23-26, 2013",
    year: "2013",
    presentationType: "Oral",
    category: "Drug Delivery"
  },
  {
    id: 27,
    title: "Development of silk fibroin-Keratin 3D scaffolds as a dermal substitute",
    authors: "Nandana Bhardwaj, Dipali Devi, Nam-Joon Cho, Biman B. Mandal",
    conference: "TERMIS AP 2013",
    fullConferenceName: "TERMIS AP International conference",
    location: "Shanghai-Wuzhen, China",
    date: "October 23-26, 2013",
    year: "2013",
    presentationType: "Oral",
    category: "Wound Care"
  },
  {
    id: 28,
    title: "Cytocompatible silk scaffold-hydrogel matrix for controlled drug release",
    authors: "Saket K. Singh, Biman B. Mandal",
    conference: "BIND-12",
    fullConferenceName: "International Conference on Design of Biomaterial",
    institution: "IISC Bangalore",
    date: "December 9-11, 2012",
    year: "2012",
    presentationType: "Poster",
    category: "Drug Delivery"
  },
  {
    id: 29,
    title: "High strength silk protein scaffolds for bone repair",
    authors: "Biman B Mandal, A. Grinberg, E. S. Gil, B. Panilaitis, David L. Kaplan",
    conference: "3rd TERMIS World Congress",
    fullConferenceName: "3rd TERMIS World Congress",
    location: "Vienna, Austria",
    date: "September 05-08, 2012",
    year: "2012",
    presentationType: "Poster",
    category: "Orthopedic Devices"
  },
  {
    id: 30,
    title: "Versatile biomaterial scaffold platform for critical-sized tissue construct",
    authors: "J. Rnjak-Kovacina, L. S. Wray, Biman B. Mandal, E. S. Gil, A. S. Weiss, David L. Kaplan",
    conference: "3rd TERMIS World Congress",
    fullConferenceName: "3rd TERMIS World Congress",
    location: "Vienna, Austria",
    date: "September 05-08, 2012",
    year: "2012",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 31,
    title: "Versatile biological scaffolding platform for building critically-sized tissue constructs",
    authors: "Lindsay S. Wray, Jelena Rnjak-Kovacina, Biman B. Mandal, Xiao Hu, David L. Kaplan",
    conference: "Biologic Scaffolds Symposium",
    fullConferenceName: "The 7th Symposium on Biologic Scaffolds for Regenerative Medicine",
    location: "Napa Valley, CA",
    year: "2012",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 32,
    title: "Hierarchical silk scaffolds for Intervertebral disc engineering",
    authors: "Biman B. Mandal, S. H. Park, E. S. Gil, David L. Kaplan",
    conference: "TERMIS AP 2011",
    fullConferenceName: "TERMIS AP Conference",
    location: "Singapore",
    date: "August 3-5, 2011",
    year: "2011",
    presentationType: "Oral",
    category: "Orthopedic Devices"
  },
  {
    id: 33,
    title: "Hierarchical silk laminates for tissue formation",
    authors: "Biman B. Mandal, David L. Kaplan",
    conference: "BMES 2010",
    fullConferenceName: "BMES Conference",
    location: "Austin, Texas, USA",
    date: "October 6-9, 2010",
    year: "2010",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 34,
    title: "Patterned silk film scaffolds for lamellar bone tissue engineering",
    authors: "L. W. Tien, E. S. Gil, S. H. Park, Biman B. Mandal, David L. Kaplan",
    conference: "BMES 2010",
    fullConferenceName: "BMES Conference",
    location: "Austin, Texas, USA",
    date: "October 6-9, 2010",
    year: "2010",
    presentationType: "Poster",
    category: "Orthopedic Devices"
  },
  {
    id: 35,
    title: "Multilayered silk scaffolds for meniscus tissue engineering",
    authors: "Biman B. Mandal, S. H. Park, E. S. Gil, David Kaplan",
    conference: "TERMIS EU 2010",
    fullConferenceName: "TERMIS EU Conference",
    location: "Ireland",
    date: "June 13-17, 2010",
    year: "2010",
    presentationType: "Oral",
    category: "Tissue Engineering"
  },
  {
    id: 36,
    title: "Corneal Tissue Engineering Using Patterned and Porous Silk Films",
    authors: "E. S. Gil, Biman B. Mandal, S. H. Park, J. Merchant, F. Omenetto, David Kaplan",
    conference: "2nd TERMIS World Conference",
    fullConferenceName: "2nd TERMIS World Conference",
    location: "Seoul, Korea",
    date: "August 31 - September 3, 2009",
    year: "2009",
    presentationType: "Poster",
    category: "Tissue Engineering"
  },
  {
    id: 37,
    title: "Non-mulberry Silk Proteins: Advanced Natural Biomaterial for Tissue Engineering and Drug Delivery",
    authors: "C. Acharya, R. Dash, Biman B. Mandal, J. Kundu, N. Bharadwaj, S. Nayak, S. Talukdar, M. Dewan, B. Kundu, S. C. Kundu",
    conference: "2nd TERMIS World Conference",
    fullConferenceName: "2nd TERMIS World Conference",
    location: "Seoul, Korea",
    date: "August 31 - September 3, 2009",
    year: "2009",
    presentationType: "Oral",
    category: "Biomaterial Processing"
  },
  {
    id: 38,
    title: "Self assembled silk sericin/poloxamer nanoparticles as nanocarriers for targeted delivery",
    authors: "Biman B. Mandal, S.C. Kundu",
    conference: "Indo-Australian Conference",
    fullConferenceName: "3rd Indo-Australian Conference on Biomaterials, Implants, Tissue engineering and Regenerative Medicine",
    location: "Australia",
    date: "January 14-16, 2008",
    year: "2008",
    presentationType: "Invited Lecture",
    category: "Drug Delivery"
  },
  {
    id: 39,
    title: "Silk proteins fibroin and sericin as potential biopolymers for tissue engineering",
    authors: "Biman B. Mandal, S. C. Kundu",
    conference: "BTEB 2008",
    fullConferenceName: "International conference on Biomaterials and Tissue Engineering for Biotechnological Applications",
    institution: "IIT Kharagpur, India",
    date: "November 22-24, 2008",
    year: "2008",
    presentationType: "Oral/Poster",
    category: "Biomaterial Processing"
  },
  {
    id: 40,
    title: "Non-mulberry silk fibroin protein as biomaterial",
    authors: "Biman B. Mandal, Chitrangada Acharya, Rupesh Dash, Joydip Kundu, S. C. Kundu",
    conference: "Fibrous Proteins 2008",
    fullConferenceName: "International conference on Fibrous proteins",
    location: "Australia",
    date: "March 31 - April 2, 2008",
    year: "2008",
    presentationType: "Invited Lecture",
    category: "Biomaterial Processing"
  },
  {
    id: 41,
    title: "Novel silk protein sericin-gelatin 2D films and 3D scaffolds",
    authors: "Biman B. Mandal, Anjana S. Priya, S. C. Kundu",
    conference: "CCMB 2007",
    fullConferenceName: "International Conference on Cellular and Molecular Bioengineering",
    location: "Singapore",
    date: "December 10-12, 2007",
    year: "2007",
    presentationType: "Oral",
    category: "Tissue Engineering"
  },
  {
    id: 42,
    title: "Cell based tissue engineering using natural polymers",
    authors: "Chitrangada Acharya, Rupesh Dash, Biman B. Mandal, Joydip Kundu, S. C. Kundu",
    conference: "Cell Tissue Engineering Workshop",
    fullConferenceName: "International workshop on Cell based tissue engineering using natural polymers",
    institution: "Gwangju Institute of Science and Technology",
    location: "Gwangju, Korea",
    date: "November 28-29, 2007",
    year: "2007",
    presentationType: "Invited Lecture",
    category: "Tissue Engineering"
  },
  {
    id: 43,
    title: "Silk protein matrices for cell-based biomedical applications",
    authors: "Chitrangada Acharya, Rupesh Dash, Biman B. Mandal, Joydip Kundu, S. C. Kundu",
    conference: "FTCMP 2007",
    fullConferenceName: "International conference on Future trends in composite materials and processing",
    institution: "IIT Kanpur, India",
    date: "December 12-14, 2007",
    year: "2007",
    presentationType: "Invited Lecture",
    category: "Biomaterial Processing"
  },
  {
    id: 44,
    title: "7th Indo-US Flow Cytometry Workshop",
    authors: "Biman B. Mandal",
    conference: "Flow Cytometry Workshop",
    fullConferenceName: "7th Indo-US Flow Cytometry Workshop",
    institution: "School of Biotechnology, JNU",
    location: "New Delhi",
    date: "February 10-14, 2007",
    year: "2007",
    presentationType: "Participation",
    category: "Research"
  },
  {
    id: 45,
    title: "International Conference on Animal models in Stem Cells",
    authors: "Biman B. Mandal",
    conference: "Animal Models Conference",
    fullConferenceName: "International Conference on Animal models in Stem Cells",
    institution: "EPFL",
    location: "Switzerland",
    date: "December 15, 2006",
    year: "2006",
    presentationType: "Participation",
    category: "Research"
  },
  {
    id: 46,
    title: "National Conference on Biomaterial, Tissue Engineering and Medical Diagnostics",
    authors: "Biman B. Mandal",
    conference: "BTMD 2006",
    fullConferenceName: "National Conference on Biomaterial, Tissue Engineering and Medical Diagnostics",
    institution: "IIT Delhi",
    date: "February 24-26, 2006",
    year: "2006",
    presentationType: "Participation",
    category: "Research"
  }
];

const Conferences = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedType, setSelectedType] = useState('All');
  const [expandedYears, setExpandedYears] = useState({});

  const categories = ['All', ...new Set(conferencesData.map(c => c.category))];
  const presentationTypes = ['All', ...new Set(conferencesData.map(c => c.presentationType))];

  const stats = {
    total: conferencesData.length,
    oral: conferencesData.filter(c => c.presentationType === 'Oral').length,
    poster: conferencesData.filter(c => c.presentationType === 'Poster').length,
    awards: conferencesData.filter(c => c.award).length,
    international: conferencesData.filter(c => c.location && (c.location.includes('USA') || c.location.includes('China') || c.location.includes('Korea') || c.location.includes('Australia') || c.location.includes('Austria') || c.location.includes('Singapore') || c.location.includes('Nepal'))).length,
  };

  const getFilteredConferences = () => {
    return conferencesData.filter(conf => {
      const matchesCategory = selectedCategory === 'All' || conf.category === selectedCategory;
      const matchesType = selectedType === 'All' || conf.presentationType === selectedType;
      return matchesCategory && matchesType;
    });
  };

  const filteredConferences = getFilteredConferences();

  const conferencesByYear = filteredConferences.reduce((acc, conf) => {
    const year = conf.year;
    if (!acc[year]) acc[year] = [];
    acc[year].push(conf);
    return acc;
  }, {});

  const toggleYear = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  const getPresentationTypeColor = (type) => {
    switch(type) {
      case 'Oral': return '#667eea';
      case 'Poster': return '#3b82f6';
      case 'Invited Lecture': return '#8b5cf6';
      case 'Oral/Poster': return '#ec4899';
      case 'Participation': return '#14b8a6';
      default: return '#6b7280';
    }
  };

  return (
    <div className="conference-page">
      <div className="conference-container">
        
        {/* Header Section */}
        <section className="conference-header">
          <h1 className="conference-title">Conferences & Presentations</h1>
          <p className="conference-subtitle">Research contributions and presentations at national and international conferences</p>
        </section>

        {/* Statistics Section
        <section className="conference-stats-bar">
          <div className="stat-item">
            <span className="stat-value">{stats.total}</span>
            <span className="stat-label">Total Presentations</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.oral}</span>
            <span className="stat-label">Oral Presentations</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.poster}</span>
            <span className="stat-label">Poster Presentations</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.awards}</span>
            <span className="stat-label">Awards Won</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.international}</span>
            <span className="stat-label">International</span>
          </div>
        </section> */}

        {/* Controls Section */}
        <section className="conference-controls">
          <div className="filter-section">
            <h4 className="filter-title">Filter by Category</h4>
            <div className="filter-tabs">
              {categories.map(cat => {
                const count = cat === 'All' 
                
                return (
                  <button
                    key={cat}
                    className={`filter-tab ${selectedCategory === cat ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(cat)}
                  >
                    {cat}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="filter-section">
            <h4 className="filter-title">Filter by Presentation Type</h4>
            <div className="filter-tabs">
              {presentationTypes.map(type => {
                const count = type === 'All' 
                
                return (
                  <button
                    key={type}
                    className={`filter-tab ${selectedType === type ? 'active' : ''}`}
                    onClick={() => setSelectedType(type)}
                  >
                    {type}
                  </button>
                );
              })}
            </div>
          </div>
        </section>

        {/* Conferences Display Section */}
        <section className="conferences-list">
          {filteredConferences.length > 0 ? (
            Object.keys(conferencesByYear).sort((a, b) => b - a).map(year => (
              <div key={year} className="year-section">
                <div 
                  className="year-header"
                  onClick={() => toggleYear(year)}
                >
                  <h3 className="year-title">
                    {year}
                    <span className="year-presentations-count">
                    </span>
                  </h3>
                  <svg className={`year-toggle ${expandedYears[year] ? 'expanded' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M19 9l-7 7-7-7" /></svg>
                </div>
                {expandedYears[year] && (
                  <div className="year-presentations">
                    {conferencesByYear[year].map((conf, index) => (
                      <div key={conf.id} className="conference-card">
                        <div className="conference-content">
                          <h4 className="conference-title-text">{conf.title}</h4>
                          <p className="conference-authors">{conf.authors}</p>
                          <p className="conference-details">
                            <span className="conference-name">{conf.conference}</span>
                            {conf.fullConferenceName && conf.fullConferenceName !== conf.conference && (
                              <span className="conference-full-name"> - {conf.fullConferenceName}</span>
                            )}
                          </p>
                          {(conf.institution || conf.location) && (
                            <p className="conference-location">
                              {conf.institution && <span>{conf.institution}</span>}
                              {conf.institution && conf.location && <span>, </span>}
                              {conf.location && <span>{conf.location}</span>}
                            </p>
                          )}
                          <div className="conference-meta">
                            <span className="conference-date">{conf.date}</span>
                            <span 
                              className="presentation-type-badge"
                              style={{ backgroundColor: getPresentationTypeColor(conf.presentationType) }}
                            >
                              {conf.presentationType}
                            </span>
                            {conf.award && (
                              <span className="award-badge">{conf.award}</span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="no-results">
              <svg className="no-results-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <h3>No presentations found</h3>
              <p>Try adjusting your filters</p>
              <button
                className="reset-btn"
                onClick={() => {
                  setSelectedCategory('All');
                  setSelectedType('All');
                }}
              >
                Reset Filters
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Conferences;